import './Technologies.css';
import { techs } from './techs';

function Technologies() {
  const techsList = techs.map((tech, idx) => {
    return (
      <div
        key={idx}
        className='tech-frames background-animation'
      >
        <img
          src={tech.image}
          alt={tech.name}
        />
        <h3>{tech.name}</h3>
      </div>
    );
  });
  return (
    <section
      id='techs'
      className='techs-container'
    >
      <h1>Some of the technologies I use</h1>
      <div className='techs-grid-container'>{techsList}</div>
      <h3>And more...</h3>
    </section>
  );
}

export default Technologies;
